import React from 'react';
import { List } from 'antd';
import Notification from '../Notification/Notification';
import { useOnlyUnreadState } from '../../../../features/toggleOnlyUnread';
import { useNotificationModeState } from '../../../../features/changeMode';
import { getShownNotifications } from '../../lib';
import styles from './NotificationList.module.scss';

const NotificationList = ({ notifications, onLinkClick }) => {
  const onlyUnread = useOnlyUnreadState();
  const mode = useNotificationModeState();

  const displayNotifications = getShownNotifications({
    notifications,
    mode,
    onlyUnread,
  });

  return (
    <List
      className={styles.root}
      size="small"
      dataSource={displayNotifications}
      renderItem={(notification) => (
        <Notification notification={notification} onLinkClick={onLinkClick} />
      )}
    />
  );
};

export default NotificationList;
